// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";

function BlikCodePaymentInput(props) {
  var match = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userBlikCode);
  var setblikCode = match[1];
  var blikCode = match[0];
  var blikCodeRef = React.useRef(null);
  var formatBSB = function (bsb) {
    var formatted = bsb.replace(/\D+/g, "");
    var firstPart = formatted.slice(0, 3);
    var secondPart = formatted.slice(3, 6);
    if (formatted.length <= 3) {
      return firstPart;
    } else if (formatted.length > 3 && formatted.length <= 6) {
      return firstPart + "-" + secondPart;
    } else {
      return formatted;
    }
  };
  var changeblikCode = function (ev) {
    var val = ev.target.value;
    setblikCode(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.value = formatBSB(val);
          return newrecord;
        });
  };
  React.useEffect((function () {
          setblikCode(function (prev) {
                var newrecord = Caml_obj.obj_dup(prev);
                var val = prev.isValid;
                newrecord.errorString = val !== undefined && !val ? "Invalid blikCode" : "";
                return newrecord;
              });
        }), [blikCode.isValid]);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && blikCode.value === "") {
            return setblikCode(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.errorString = "blikCode cannot be empty";
                        return newrecord;
                      });
          }
          
        }), [blikCode]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: true,
              children: React.createElement(PaymentField$OrcaPaymentPage.make, {
                    setValue: setblikCode,
                    value: blikCode,
                    onChange: changeblikCode,
                    fieldName: "Blik code",
                    name: "blikCode",
                    type_: "blikCode",
                    paymentType: "Payment",
                    maxLength: 7,
                    placeholder: "000 000",
                    inputRef: blikCodeRef
                  })
            });
}

var make = BlikCodePaymentInput;

export {
  make ,
}
/* react Not a pure module */
